import { envConfig } from '../../env-config';
import { getSubdomain } from '../get-config/parse-url';
export const isV1Flow = (flowConfig) => !flowConfig || ['1.0.0', null].includes(flowConfig.consumerAppVersion);
export const getExistingConsumerDomain = () => getSubdomain(envConfig.consumerUrl);
